export default "__VITE_ASSET__Bd2DXPRA__"